import T from 'prop-types';
import React from 'react';
import UploadableImage from 'shared/components/uploadable-image';
import { DEFAULT_THUMBNAIL } from '../../../../../../shared/helpers/markers';
import { markerPropType } from '../../../../../../customPropTypes';

const ThumbnailField = ({ marker, onChange }) => {
  const imageSrc = marker.thumbnail.original || DEFAULT_THUMBNAIL;

  return (
    <div className="field--thumbnail">
      <UploadableImage
        entity={marker.id}
        name="thumbnail"
        src={imageSrc}
        onImageUploaded={onChange}
        onImageRemoved={() => {
          onChange(null);
        }}
        enableRemove={!!imageSrc && imageSrc !== DEFAULT_THUMBNAIL}
        minimumImageSize={600}
      />
    </div>
  );
};

ThumbnailField.propTypes = {
  marker: markerPropType.isRequired,
  onChange: T.func.isRequired,
};

export default ThumbnailField;
